import React from "react";
import { Segment, Button, Form, Header } from "semantic-ui-react";
import { Field } from "redux-form";
import * as phases from "../../../utils/helpers/phases";
export const ResetPasswordComponent = ({ handleSubmit, phase, t }) => {
  return (
    <Segment basic>
      <Form onSubmit={handleSubmit}>
        <Header as="h4" style={{ color: "white" }}>
          Enter your new password
        </Header>
        <Field
          name="password"
          type="password"
          component={Form.Input}
          fluid
          icon="lock"
          iconPosition="left"
          placeholder={t("register:passwordPlaceholder")}
        />
        <Field
          name="confirmpassword"
          type="password"
          component={Form.Input}
          fluid
          icon="lock"
          iconPosition="left"
          placeholder={t("register:confirmPasswordPlaceholder")}
        />
        <Button
          fluid
          type="submit"
          color="orange"
          lloading={phase === phases.LOADING}
          disabled={phase === phases.LOADING}>
          {t("resetPassword:resetPasswordButton")}
        </Button>
      </Form>
    </Segment>
  );
};



// WEBPACK FOOTER //
// ./src/users/loggedUser/ResetPassword/ResetPasswordComponent.js